/**
 * Developer console auth — a SEPARATE auth track from `auth`.
 *
 * `data`  : false when logged out, otherwise the dev session returned by the
 *           backend dev-auth endpoint, e.g.
 *             { token: "<dev jwt>", identity: { uuid, name }, expiresAt: "<iso>" }
 * `active`: true only while the current route is inside the developer console
 *           (route meta.requiresDev). Kept in sync by router.afterEach. Used by
 *           src/objects/api.js to decide whether to attach the dev token instead
 *           of the normal user token, so the two sessions never cross-contaminate.
 *
 * Page access to the developer console is governed SOLELY by `data.token` —
 * a normal user session (store.state.auth) grants nothing here.
 */
export default {
  state: {
    data: false,
    active: false,
  },
  getters: {
    //
  },
  actions: {
    devLogout(context) {
      context.commit("updateDevAuth", false);
    },
  },
  mutations: {
    updateDevAuth(state, data) {
      return (state.data = data);
    },
    setDevActive(state, val) {
      return (state.active = val);
    },
  },
};
